import React, { useEffect, useState } from "react";
import { NavigateNext } from "@mui/icons-material";

import ConfettiCelebration from "../ConfettiCelebration";
import { Chapter } from "./Chapter";
import Renderer from "../renderer";
import Button from '../Button';
import { useQuiz } from "../../pages/quiz/hooks";
import { Box, Grid, Slider, Typography } from "@mui/material";
import { DiagnosticHeader as Header } from './Header';
import { makeStyles } from "tss-react/mui";
import { getById } from "../../store/course/courseBaseApi";

const useStyles = makeStyles()((theme) => ({
    root: {
        height: '100%',
    },
    gridContainer: {
        padding: 1,
    },
    gridBox: {
        display: 'flex',
        // [theme.breakpoints.up('md')]: {
        //     justifyContent: 'flex-start',
        // },
        // marginLeft: theme.spacing(1),
        // marginTop: theme.spacing(1),
    },
    sectionName: {
        color: '#464255',
        fontSize: '1em',
        fontFamily: '"Quicksand", sans-serif',
        fontWeight: 700,
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.3em',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.5em',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '1.5em',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2em',
        },
    },
    sliderRoot: {
        width: '50%',
        height: 8,
        color: '#e0e7ff',
    },
    sliderRail: {
        height: 8,
        opacity: 1,
        backgroundColor: '#D0DAFF',
        border: '5px solid #fff',
    },
    sliderTrack: {
        height: 8,
        borderRadius: 4,
        backgroundColor: '#4A8EFF',
    },
    sliderThumb: {
        height: 34,
        width: 34,
        borderRadius: '50%',
        position: 'relative',
        background: '#4A8EFF',
        border: '8px solid white',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        '&:hover, &.Mui-focusVisible': {
            boxShadow: '0px 0px 0px 8px rgba(59, 130, 246, 0.16)',
        },
        '&.Mui-active': {
            boxShadow: '0px 0px 0px 12px rgba(59, 130, 246, 0.16)',
        },
        '&::before': {
            content: '""',
            display: 'block',
            width: '80%',
            height: '80%',
            borderRadius: '50%',
            background: '#398CE2',
            position: 'absolute',
            zIndex: -1,
        },
        '&::after': {
            content: '""',
            display: 'block',
            width: '120%',
            height: '120%',
            borderRadius: '50%',
            background: 'linear-gradient(193.28deg, #B3B3B3 5.42%, #B6B6B6 40%, #C2C2C2 79%, #CCCCCC 99%)',
            position: 'absolute',
            border: '2px solid #aaa7a7',
            opacity: 0.3,
            zIndex: -2,
        },
    },

}))
export const Section = ({ section, style, mapping, onSectionCompletion, currentSection, meta, totalSections, onTestComplete }) => {
    const { classes } = useStyles();
    const { gradingResult, setSelectedDiagnosticTestMapping } = useQuiz();
    const [chapter, setChapter] = React.useState({});
    const [course, setCourse] = useState({});
    const [currentChapter, setCurrentChapter] = React.useState(0);
    const [chapterCompleted, setChapterCompleted] = React.useState(false);
    const [buttonText, setButtonText] = React.useState('Next');
    const [completed, setCompleted] = React.useState(false);
    const [sectionComplete, setSectionComplete] = React.useState(false);
    const [assessmentBegin, setAssessmentBegin] = useState(false);
    const [assessmentEnded, setAssessmentEnded] = useState(false);

    const [showConfetti, setShowConfetti] = React.useState(false);

    const totalChapters = React.useRef(section?.chapters?.length || 0);

    const [totalSentence, setTotalSentence] = useState();
    const [completedSentence, setCompletedSentence] = useState();

    const completionPercentage = (completedSentence / totalSentence) * 100;

    const onChapterComplete = () => {
        setChapterCompleted(true);

        if (currentSection == (totalSections - 1)) {
            return setShowConfetti(true);
        }
    }

    const handleSectionCompletion = () => {
        if (onSectionCompletion && typeof onSectionCompletion === 'function') {
            onSectionCompletion();
        }
        setSectionComplete(true);
    }

    const onConfettiClose = () => {
        setShowConfetti(false);
        setSectionComplete(false);

        if (currentSection == (totalSections - 1)) {
            return handleSectionCompletion()
        }

        onNextChapter();
    }

    const onNextChapter = () => {
        if (currentChapter < totalChapters.current) {
            setCurrentChapter(currentChapter + 1);
        } else {
            if (onSectionCompletion && typeof onSectionCompletion === 'function') {
                onSectionCompletion();
            }

            setCurrentChapter(0);
        }

        setChapterCompleted(false);
    }
    useEffect(() => {
        if (mapping && Object.keys(mapping).length) {
            setSelectedDiagnosticTestMapping({ ...mapping, section: section.name });
        }
    }, [mapping])

    React.useEffect(() => {
        if (chapterCompleted && sectionComplete) {
            setShowConfetti(true);
        }
    }, [chapterCompleted]);

    React.useEffect(() => {
        if (currentChapter === totalChapters.current) {
            if (currentSection == (totalSections - 1)) {
                setCompleted(true);

                if (onTestComplete && typeof onTestComplete === 'function') {
                    onTestComplete();
                }
            }
            setChapter({});
            setChapterCompleted(true);

            setButtonText('Start next section');
        } else if (currentChapter == totalChapters.current - 1) {
            setSectionComplete(true);
            setButtonText('Finish');
        } else {
            setButtonText('Next chapter');
        }

        if (section?.chapters[currentChapter]) {
            setChapter(section.chapters[currentChapter]);
        }
    }, [currentChapter]);

    React.useEffect(() => {
        setChapter(section?.chapters[0]);
    }, [section]);

    const loadCourse = async (id) => {
        let { data } = await getById({ id: id });
        setCourse(data)
    }

    useEffect(() => {
        if (mapping) {
            loadCourse(mapping?.courseId)
        }
    }, [mapping])

    return (
        // <div style={{...style, ...styles.container}}>
        //     <Typography sx={{mb: 1}} variant="h5">{section.name}</Typography>

        //     {Object.keys(chapter).length > 0 && <Chapter meta={meta} mapping={mapping} onComplete={onChapterComplete} sectionId={section.sectionId} data={chapter} />}

        //     {!completed && chapterCompleted && !sectionComplete && (
        //         <div style={styles.btnContainer}>
        //             <Button
        //                 icon={<NavigateNext />}
        //                 onClick={onNextChapter}
        //                 variant="contained"
        //                 size="lg"
        //                 placeholder={buttonText}
        //                 sx={{
        //                     minWidth: '100px',
        //                     background: 'var(--mui-palette-primary-button)',
        //                     p: 1,
        //                     my: 4
        //                 }}
        //             />
        //         </div>
        //     )}

        //     <ConfettiCelebration onClose={onConfettiClose} open={showConfetti} message={confettiMessage + (hasNextAssessment() ? '\n\nPlease click "Okay" to proceed to the next level assignment' : '')} />
        // </div>
        <Box className={classes.root} >
            {!assessmentEnded &&
                (!assessmentBegin ?
                    <Grid className={classes.gridContainer} container spacing={2} >
                        <Grid item xs={12} md={5} lg={5} >
                            <Box className={classes.gridBox} sx={{ justifyContent: { xs: 'center', sm: 'center', md: 'flex-start', lg: 'flex-start', xl: 'flex-start' }, ml: 1, mt: 1 }}>
                                <Typography className={classes.sectionName} > {course?.courseName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={7} lg={7} >
                            <Box className={classes.gridBox} sx={{ justifyContent: { xs: 'center', sm: 'center', md: 'flex-start', lg: 'flex-start', xl: 'flex-start' }, ml: 1, mt: 1 }}>
                                <Slider
                                    classes={{
                                        root: classes.sliderRoot,
                                        rail: classes.sliderRail,
                                        track: classes.sliderTrack,
                                        thumb: classes.sliderThumb,
                                    }}
                                    value={completionPercentage}
                                    disabled
                                />
                            </Box>
                        </Grid>
                    </Grid>
                    : <Header />)
            }

            {Object.keys(chapter).length > 0 && <Chapter meta={meta} mapping={mapping} onComplete={onChapterComplete} sectionId={section.sectionId} data={chapter} setCompletedSentence={setCompletedSentence} setTotalSentence={setTotalSentence} assessmentBegin={assessmentBegin} setAssessmentBegin={setAssessmentBegin} setAssessmentEnded={setAssessmentEnded} onConfettiClose={onConfettiClose} />}

            {
                !completed && chapterCompleted && !sectionComplete && (
                    <div style={styles.btnContainer}>
                        <Button
                            icon={<NavigateNext />}
                            onClick={onNextChapter}
                            variant="contained"
                            size="lg"
                            placeholder={buttonText}
                            sx={{
                                minWidth: '100px',
                                background: 'var(--mui-palette-primary-button)',
                                p: 1,
                                my: 4
                            }}
                        />
                    </div>
                )
            }

            {/* <ConfettiCelebration onClose={onConfettiClose} open={showConfetti} message={confettiMessage + (hasNextAssessment() ? '\n\nPlease click "Okay" to proceed to the next level assignment' : '')} /> */}
        </Box >
    )
}

const styles = {
    container: {
        position: 'relative'
    },
    renderer: {
        color: 'var(--mui-palette-text-primary)',
        width: '100%',
        marginBottom: '2rem'
    },
    btnContainer: {
        display: 'flex',
        justifyContent: 'center'
    }
}